import React, { Component } from 'react';
import { Badge } from 'react-bootstrap';

class EmpresaTenancyStatus extends Component {

  render() {
    const { live } = this.props.data;

    let text = !!live ? ' Live ' : ' Test ';
    let variant = !!live ? 'live' : 'test';

    return <Badge variant={ variant }>{ text }</Badge>
  }
}

export default EmpresaTenancyStatus;